import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import MobileController from './pages/MobileController';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/s/:token" element={<MobileController />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
